"use strict";

var _constants = require("./constants");
var _utils = require("./utils");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
_constants.TIME_INDEPENDENT_FN_NAMES.forEach(function (apiFuncName) {
  module.exports[apiFuncName] = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return callOrAddToCPLStub(apiFuncName, args);
  };
});
_constants.TIME_DEPENDENT_FN_NAMES.forEach(function (apiFuncName) {
  module.exports[apiFuncName] = function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    // If ClientProfiler is already available, just directly call
    if (getCP()) {
      return callOrAddToCPLStub(apiFuncName, args);
    }
    var _window = window,
      perf = _window.performance;
    if (typeof perf === 'undefined') {
      console.warn((0, _utils.generateWarnMessage)(apiFuncName, args, '`window.performance` is undefined'));
      return false;
    }
    /* eslint-disable default-case */
    switch (apiFuncName) {
      case 'profile':
      case 'profileIntervalBegin':
        {
          var eventName = args[0];
          perf.mark(eventName);
          callOrAddToCPLStub(apiFuncName, [eventName, {
            isAlreadyMarked: true
          }]);
          break;
        }
      case 'profileIntervalEnd':
        {
          var _eventName = args[0],
            startEventName = args[1];
          var endEventName = "".concat(_eventName, "_internal_clickstream_end");
          perf.mark(endEventName);
          var opts = {
            endEventName: endEventName
          };
          callOrAddToCPLStub('profileIntervalEnd', [_eventName, startEventName, opts]);
          break;
        }
    }
    return undefined;
  };
});

/**
 * returns Client Profiler stub or creates a new one.
 * The stub keeps track of calls to Client Profiler
 * The Clickstream Web SDK will replay the calls when it loads
 *
 * @returns {array} client profiler stub
 */
function getOrCreateCPLStub() {
  if (typeof window === 'undefined') {
    return undefined;
  }
  if (window.clientProfilerStub) {
    return window.clientProfilerStub;
  }
  window.clientProfilerStub = [];
  return window.clientProfilerStub;
}

/**
 * returns Client Profiler or undefined
 *
 * @returns {ClientProfiler} Client Profiler
 */
function getCP() {
  return typeof window !== 'undefined' && window.ClientProfiler ? window.ClientProfiler : undefined;
}

/**
 * Proxies call to window.ClientProfiler or adds it to the stub
 *
 * @param {string} functionName name of the Client Profiler function
 * @param {Array} args the arguments passed to the Client Profiler function
 *
 * @returns {any | false | undefined} response from the Client Profiler function
 * Returns false if errors occur. Returns undefined if added to stub.
 */
function callOrAddToCPLStub(functionName, args) {
  var clientProfiler = getCP();
  if (typeof clientProfiler !== 'undefined') {
    try {
      return clientProfiler[functionName].apply(clientProfiler, _toConsumableArray(args));
    } catch (err) {
      console.warn((0, _utils.generateWarnMessage)(functionName, args, err));
      return false;
    }
  }
  var cplStub = getOrCreateCPLStub();
  if (!cplStub) {
    console.warn((0, _utils.generateWarnMessage)(functionName, args, '`window` is undefined'));
    return false;
  }
  cplStub.push({
    functionName: functionName,
    args: args
  });
  return undefined;
}